/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface ShareIconProps {
  size?: number
  color?: string
}

/**
 * SVG share/upload icon used in share triggers.
 * @param size - Icon dimensions in px (default 16)
 * @param color - Fill color (defaults to SOLITUDE from appColors)
 */
function ShareIcon({ size = 16, color = colors.SOLITUDE }: ShareIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 -960 960 960'
      fill={color}
    >
      <path d='M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h120v80H240v400h480v-400H600v-80h120q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm200-240v-447l-64 64-56-57 160-160 160 160-56 57-64-64v447h-80Z' />
    </svg>
  )
}

export default ShareIcon
